import React, {useEffect, useRef, useState} from "react";
import { motion, AnimatePresence } from "framer-motion";
import { projData } from "../../globals/data";
import { primaryInput } from "detect-it";
import ProgressiveBackgroundImg from "../ProgressiveBackgroundImg/ProgressiveBackgroundImg";
import './styles.css';
import { archvTransVariants, backgroundWrapperVariants, curveVariants, maskScalerVariants, scalerVariants, sideCurveVariantd, svgTestVariants } from "./variants";
import { wiperDelay, wiperDuration } from "./variables";
import { gridTileScales } from "../../globals/variables";


const HomeToArchiveTransition = ({homeToArchiveTransitionTrigger}) => {
    const [tileHeight, setTileHeight] = useState(null);
    const [tileWidth, setTileWidth] = useState(null);
    const [scaleDownX, setScaleDownX] = useState(null);
    const [scaleDownY, setScaleDownY] = useState(null);

    const [bScaleDownX, setBScaleDownX] = useState(null);
    const [bScaleDownY, setBScaleDownY] = useState(null);
    const [bTileHeight, setBTileHeight] = useState(null);
    const [bTileWidth, setBTileWidth] = useState(null);


    const topCurveRef = useRef(null);
    const bottomCurveRef = useRef(null);
    const leftCurveRef = useRef(null);
    const rightCurveRef = useRef(null);

    const mainBgRef = useRef(null);
    const visBackgroundRef = useRef(null);
    const backgroundWrapperRef = useRef(null);



    const responsiveResize = () => {
        let curHeight = window.innerHeight;

        let targHeight;
        let targWidth;
        if(primaryInput == 'mouse'){
            // Homepage Transition Is 20dvh
            targHeight = (curHeight/5) - 19;
            targWidth = 1 + (curHeight/5) * 1.9;
        } else{
            targHeight = (curHeight/4) - 19;
            targWidth = 1 + ((curHeight/4) - 20) * (4/3) * 1.25;
        }
        setTileHeight(targHeight)
        setTileWidth(targWidth)

        let divider;
        if(primaryInput == "mouse"){
            divider = 5;
        } else {
            divider = 4;
        }
        let bStarter =((window.innerHeight/divider) * 1.9)
        let bWidth = bStarter * gridTileScales[0];
        let bHeight = ((window.innerHeight/divider) - 20) * gridTileScales[1]

        setBTileWidth(bWidth)
        setBTileHeight(bHeight)
    }

    useEffect(() => {
        let useEle = backgroundWrapperRef.current;
        if(useEle && tileHeight && tileWidth){
            try{
                let elePos = useEle.getBoundingClientRect();
                let eleHeight = elePos.height;
                let eleWidth = elePos.width;

                let tmpScaleDownX = tileWidth/eleWidth;
                let tmpScaleDownY = tileHeight/eleHeight;

                setScaleDownX(tmpScaleDownX);
                setScaleDownY(tmpScaleDownY);
            } catch{}
        }
    }, [tileHeight, tileWidth,backgroundWrapperRef.current])

    useEffect(() => {
        let useEle = backgroundWrapperRef.current;
        if(useEle && bTileHeight && bTileWidth){
            let elePos = useEle.getBoundingClientRect();
            let eleHeight = elePos.height;
            let eleWidth = elePos.width;

            let tmpScaleDownX = bTileWidth/eleWidth;
            let tmpScaleDownY = bTileHeight/eleHeight;
            
            setBScaleDownX(tmpScaleDownX);
            setBScaleDownY(tmpScaleDownY);
        }
    }, [bTileHeight, bTileWidth, backgroundWrapperRef.current])

    useEffect(() => {
        responsiveResize();
        window.addEventListener('resize', responsiveResize, false);
    }, [])

    return(
        <>
            <div className="hta_trans__wrapper">
                <div className="archv_to_home__wrapper" >
                    <div 
                        className="archive_background_element_wrapper"
                        // exit={location.pathname.includes("project") ? "projExit" : "standardExit"}
                        ref={backgroundWrapperRef}
                    >    
                        <AnimatePresence mode="wait">
                            {
                                scaleDownX && scaleDownY && homeToArchiveTransitionTrigger !== false && 
                                <motion.div 
                                    className="hta_transition_content__wrapper"
                                    style={{
                                        height: "100%",
                                        width: "100%",
                                        transform: homeToArchiveTransitionTrigger[1] ? `scale3d(${scaleDownX}, ${scaleDownY}, 1)` : `scale3d(${bScaleDownX}, ${bScaleDownY}, 1)`,
                                    }}
                                    initial="initial"
                                    animate="animate"
                                    exit="exit"
                                    variants={backgroundWrapperVariants}
                                    custom={homeToArchiveTransitionTrigger[1] ? [scaleDownX, scaleDownY] : [bScaleDownX, bScaleDownY]}    
                                >
                                    <motion.div
                                        className="sw"
                                        ref={visBackgroundRef}
                                    >
                                        <motion.div
                                            className="archv_background_ele"
                                            style={{
                                                zIndex: 5
                                            }}
                                            ref={mainBgRef}                                                
                                        >
                                            <motion.div 
                                                className="bg_wrapper_scaler"
                                                variants={scalerVariants}
                                                custom={
                                                    homeToArchiveTransitionTrigger[1] ?
                                                        [1, scaleDownX/scaleDownY]
                                                        : 
                                                        [bScaleDownY/bScaleDownX, 1]
                                                }
                                            >
                                                <motion.video 
                                                    className="transition_wiper right_to_left"
                                                    style={{
                                                        height: "100%",
                                                        width: "100%",
                                                        objectFit: "cover",
                                                        objectPosition: "center",
                                                        animationDelay: wiperDelay +"s",
                                                        animationDuration: wiperDuration +"s"
                                                    }}
                                                >
                                                    <source src={projData[0].gifStyling.backgroundImage} type="video/mp4"  media="(min-width: 601px)"/>
                                                    <source src={projData[0].gifStyling.mobileVideo} type="video/mp4"  media="(max-width: 600px)" />
                                                </motion.video>
                                            </motion.div>
                                        </motion.div>
                                    </motion.div>                       
                                    <motion.div
                                        className={`archv_background_ele invis-bg`}
                                        variants={maskScalerVariants}
                                    >
                                        <motion.div
                                            className="upper-curve-wrapper curve-wrapper"
                                            style={{
                                                position: "absolute",
                                                left: 0,
                                                top: "-100px",
                                                width: "100%"
                                            }}
                                            ref={topCurveRef}
                                        >
                                            <svg 
                                                width="auto"
                                                height="130"
                                                viewBox="0 0 531 130"
                                                preserveAspectRatio="none"
                                            >
                                                <motion.path
                                                    initial="deep"
                                                    animate="shallow"
                                                    exit="shallow"
                                                    variants={svgTestVariants}
                                                    style={{width: "100%"}}
                                                    fill="var(--dark-color)"
                                                />
                                            </svg>
                                        </motion.div>
                                        <div
                                            className="right-curve-wrapper curve-wrapper"
                                            style={{
                                                position: "absolute",
                                                right: "-100px",
                                                top: 0,
                                                height: "100%"
                                            }}
                                            ref={rightCurveRef}
                                        >
                                        <svg 
                                            width="130"
                                            height="auto"
                                            viewBox="0 0 130 532"
                                            preserveAspectRatio="none"
                                        >
                                            <motion.path
                                                initial="shallow"
                                                animate="shallow"
                                                exit="shallow"
                                                variants={sideCurveVariantd}
                                                style={{height: "100%"}}
                                                fill="var(--dark-color)"
                                            />
                                        </svg>
                                        </div>
                                        <div
                                            className="left-curve-wrapper curve-wrapper"
                                            style={{
                                                position: "absolute",
                                                left: "-100px",
                                                top: 0,
                                                height: "100%",
                                            }}
                                            ref={leftCurveRef}
                                        >
                                        <svg 
                                            width="130"
                                            height="auto"
                                            viewBox="0 0 130 532"
                                            preserveAspectRatio="none"
                                            style={{
                                                transform: "rotate(180deg)"
                                            }}
                                        >
                                            <motion.path
                                                initial="shallow"
                                                animate="shallow"
                                                exit="shallow"
                                                variants={sideCurveVariantd}
                                                style={{height: "100%"}}
                                                fill="var(--dark-color)"
                                            />
                                        </svg>
                                        </div>
                                        <motion.div
                                            className="lower-curve-wrapper curve-wrapper"
                                            style={{
                                                position: "absolute",
                                                left: 0,
                                                bottom: "-100px",
                                                width: "100%"
                                            }}
                                            ref={bottomCurveRef}
                                            // variants={curveVariants}
                                        >
                                            <svg 
                                                width="auto"
                                                height="130"
                                                viewBox="0 0 531 130"
                                                preserveAspectRatio="none"
                                                style={{transform: "rotate(180deg)"}}
                                            >
                                                <motion.path
                                                    initial="shallow"
                                                    animate="shallow"
                                                    exit="shallow"
                                                    variants={svgTestVariants}
                                                    style={{width: "100%"}}
                                                    fill="var(--dark-color)"
                                                />
                                            </svg>
                                        </motion.div>
                                    </motion.div>
                                </motion.div>
                            }
                        </AnimatePresence>
                    </div>
                </div>
            </div>
        </>
    )
}

export default HomeToArchiveTransition;